import {
  ASSET_REPORT_EDIT_PATH,
  GENERAL_REPORT_EDIT_PATH,
  LOCATION_REPORT_EDIT_PATH
} from 'constants/routeConstants';

const REPORT_TYPES = Object.freeze({
  ASSET: 'Asset',
  LOCATION: 'Location',
  GENERAL: 'General'
});

const REPORT_ENTITIES = Object.freeze({
  LOOSE_ITEM: 'LooseItem',
  LOCATION: 'Location',
  ASSET: 'Asset'
});

const getRootPath = (type) => {
  const paths = {
    [REPORT_TYPES.ASSET]: ASSET_REPORT_EDIT_PATH,
    [REPORT_TYPES.LOCATION]: LOCATION_REPORT_EDIT_PATH,
    [REPORT_TYPES.GENERAL]: GENERAL_REPORT_EDIT_PATH
  };

  return paths[type];
};

const generateUrl = (type, values, entity) => {
  const params = new URLSearchParams({
    generalReportTemplateId: values.template.id
  });

  if (
    type === REPORT_TYPES.ASSET ||
    (type === REPORT_TYPES.GENERAL && entity === REPORT_ENTITIES.ASSET)
  ) {
    params.append('assetId', values.asset.id);
  }

  if (type === REPORT_TYPES.LOCATION) {
    const { location } = values;
    const isProject = location?.isProject ?? false;

    if (isProject) {
      params.append('projectId', location.project.id);
    } else {
      params.append('locationId', location.location.id);
    }
  }

  if (type === REPORT_TYPES.GENERAL && entity === REPORT_ENTITIES.LOCATION) {
    params.append('locationId', values.location.id);
  }

  if (type === REPORT_TYPES.GENERAL && entity === REPORT_ENTITIES.LOOSE_ITEM) {
    params.append('looseItemId', values.looseItem.id);
  }

  return `${getRootPath(type)}?${params.toString()}`;
};

const generateExistedReportUrl = (reportId) => `${LOCATION_REPORT_EDIT_PATH}/${reportId}`;

export { REPORT_TYPES, REPORT_ENTITIES, generateUrl, generateExistedReportUrl };
